module.exports = __webpack_public_path__ + "media/images/zz_title-1c5a27c0178a6d4841a274177cf7a276.png";